import styled from "styled-components";

const RequestButton = styled.button`
    font-size: 0.875rem;
    font-weight: var(--weight-bold);
    color: ${({blackwhite}) => blackwhite ? `var(--color-offwhite)` : `var(--color-primary)`};
    padding: 11px 24px;
    border: 1px solid ${({blackwhite}) => blackwhite ? `var(--color-offwhite)` : `var(--color-primary)`};
    border-radius: 100px;
    text-transform: uppercase;
    background-color: transparent;
    margin-bottom: ${({blackwhite}) => blackwhite ? `30px` : `0px`};;
`;

export default RequestButton;